'use client';

import React from 'react';
import { Send, Eye, CheckCircle, XCircle, Plus, Lock, AlertTriangle } from 'lucide-react';
import type { ActivityItem } from '@/store/appraisalStore';

interface Props {
  activities: ActivityItem[];
}

const TYPE_META: Record<string, { icon: React.ReactNode; cls: string }> = {
  submit: { icon: <Send size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--submit' },
  review: { icon: <Eye size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--review' },
  approve: { icon: <CheckCircle size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--approve' },
  reject: { icon: <XCircle size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--reject' },
  create: { icon: <Plus size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--create' },
  close: { icon: <Lock size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--close' },
  overdue: { icon: <AlertTriangle size={14} />, cls: 'pn-appraisal__activity-feed-item-icon--overdue' },
};

function timeAgo(ts: string) {
  const now = new Date('2026-05-12T04:53:17Z');
  const then = new Date(ts);
  const diffMs = now.getTime() - then.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHrs = Math.floor(diffMins / 60);
  if (diffHrs < 24) return `${diffHrs}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  return `${diffDays}d ago`;
}

export default function ActivityFeed({ activities }: Props) {
  return (
    <div className="pn-appraisal__activity-feed">
      <div className="pn-appraisal__activity-feed-header">
        <span className="pn-appraisal__activity-feed-header-title">Recent Activity</span>
        <button className="pn-appraisal__btn pn-appraisal__btn--ghost pn-appraisal__btn--sm">
          View All
        </button>
      </div>
      <div className="pn-appraisal__activity-feed-list">
        {activities.map((item) => {
          const meta = TYPE_META[item.type] || TYPE_META.create;
          return (
            <div key={item.id} className="pn-appraisal__activity-feed-item">
              <div className={`pn-appraisal__activity-feed-item-icon ${meta.cls}`}>
                {meta.icon}
              </div>
              <div className="pn-appraisal__activity-feed-item-content">
                <div className="pn-appraisal__activity-feed-item-text">
                  <strong>{item.actor}</strong> {item.action}{' '}
                  <strong>{item.target}</strong>
                </div>
                <div className="pn-appraisal__activity-feed-item-meta">
                  <span>{timeAgo(item.timestamp)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}